/**
 * Calendar API v2 configuration used for unified availability and pricing
 * endpoints.
 */

export const AVAILABILITY_CALENDAR_ENDPOINT =
  '/_/pricesearch/calendar/availability/'
export const PRICING_CALENDAR_ENDPOINT = '/_/pricesearch/calendar/pricing/'
